import type { ServiceProviderProps } from "@/providers/SRP";
import { type PropsWithChildren, useRef } from "react";
import type { StoreState } from "../types";
import Context from "./context";
import createStore, { type FundExplorerStore } from "./storeCreator";

type Props = {
	initialState?: Partial<StoreState>;
	tenant?: string;
	srpProps: ServiceProviderProps;
};

export default function StoreProvider({
	children,
	initialState,
	srpProps,
	tenant = "Tenant",
}: PropsWithChildren<Props>) {
	const store = useRef<FundExplorerStore>(null);
	if (!store.current)
		store.current = createStore(tenant, srpProps, initialState);
	return <Context.Provider value={store.current}>{children}</Context.Provider>;
}
